module.exports = __webpack_public_path__ + "static/img-hp-be-vape-free-4edf817239d2de440bf6404d702356a5.jpg";